import { Component } from 'solid-js';

interface CountryFlagProps {
  code: string;
  size?: number;
}

/**
 * CountryFlag Component
 * Displays country flags using Freak Flags sprite
 * Optimized with PNG sprite for better performance
 * Falls back to country code if flag not available
 */
const CountryFlag: Component<CountryFlagProps> = (props) => {
  const size = props.size || 20;
  const code = props.code?.toUpperCase() || 'XX';

  // Map common country codes
  const codeMap: Record<string, string> = {
    'US': 'US',
    'GB': 'GB',
    'DE': 'DE',
    'FR': 'FR',
    'JP': 'JP',
    'CN': 'CN',
    'IN': 'IN',
    'BR': 'BR',
    'RU': 'RU',
    'XX': 'US', // Fallback to US flag
  };

  const mappedCode = codeMap[code] || code;

  return (
    <div
      class={`fflag fflag-${mappedCode}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        'border-radius': '50%',
        'flex-shrink': '0',
      }}
      title={code}
    />
  );
};

export default CountryFlag;
